module.exports = __webpack_public_path__ + "img/process_1.a282f62f.svg";